module.exports = __webpack_public_path__ + "img/bolton-logo.52b51950.png";